module.exports = __webpack_public_path__ + "static/media/show-icon.68b7bf80.svg";